/*
  Translations for the signup -> plan -> Stripe flow and the Billing page.
  Merged into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const INTRO =
  'Start and Pro come with {n} days free. A card is required up front: Stripe checks it but charges nothing until day {next}, then the plan renews automatically. Cancel any time before the trial ends and you pay nothing. Team and Network are billed on the day you subscribe. One free trial per account.';
const PICKER_NOTE =
  'Start and Pro: {n} days free, card required. Charged automatically on day {next} unless you cancel. One free trial per account.';
const TRIAL_BANNER =
  'Free trial until {date}. Your card will be charged automatically on that day — nothing to do. Cancel before then in Manage billing and you pay nothing.';

const ENT_PITCH =
  'Everything in Network, on your own server or cloud, installed with one command. Unlimited users, domains and history.';
const ENT_AFTER =
  'After payment you issue your licence key on the page Self-hosted and install the tracker yourself with one command, following the step-by-step guide. If you prefer, we set it up for you or move you off your old tracker. The hosting is billed to you by your provider.';

const ru = {
  'Choose your plan': 'Выберите тариф',
  'Every plan includes the whole tracker.': 'В каждом тарифе — весь трекер целиком.',
  '{n} days free': '{n} дней бесплатно',
  'Billed today': 'Оплата сразу',
  Continue: 'Продолжить',
  [PICKER_NOTE]:
    'Start и Pro: {n} дней бесплатно, нужна карта. Списание — автоматически на {next}-й день, если не отмените. Пробный период — один на аккаунт.',
  'Could not load plans.': 'Не удалось загрузить тарифы.',
  'Try again': 'Повторить',
  Plan: 'Тариф',
  Change: 'Изменить',
  'Opening secure payment…': 'Открываем защищённую страницу оплаты…',
  'Could not open the payment page. Choose a plan to continue.':
    'Не удалось открыть страницу оплаты. Выберите тариф, чтобы продолжить.',
  [INTRO]:
    'На Start и Pro — {n} дней бесплатно. Карта нужна сразу: Stripe её проверит, но ничего не спишет до {next}-го дня, дальше тариф продлевается автоматически. Отмените до конца пробного периода — и не заплатите ничего. Team и Network оплачиваются в день подписки. Пробный период — один на аккаунт.',
  'Choose a plan to open your workspace.': 'Выберите тариф, чтобы открыть кабинет.',
  'Payment was not completed. Choose a plan to continue.': 'Оплата не завершена. Выберите тариф, чтобы продолжить.',
  'Confirming your payment…': 'Подтверждаем оплату…',
  'Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.':
    'Оплата прошла, но подтверждение задерживается. Обновите страницу через минуту.',
  'Payment confirmed. Welcome aboard!': 'Оплата подтверждена. Добро пожаловать!',
  [TRIAL_BANNER]:
    'Пробный период до {date}. В этот день карта будет списана автоматически — ничего делать не нужно. Отмените раньше в «Управлении оплатой», и списания не будет.',
  'Start {n}-day free trial': 'Начать {n} дней бесплатно',
  Subscribe: 'Оформить подписку',
  'Your free trial has already been used, so this plan is billed today.':
    'Пробный период уже использован, поэтому оплата спишется сразу.',
  'To switch plans, contact support — we move you without losing paid days.':
    'Чтобы сменить тариф, напишите в поддержку — переведём без потери оплаченных дней.',
  [ENT_PITCH]:
    'Всё из Network — на вашем сервере или в облаке, установка одной командой. Без лимитов на пользователей, домены и историю.',
  [ENT_AFTER]:
    'После оплаты вы выпускаете лицензионный ключ на странице «Свой сервер» и сами ставите трекер одной командой по пошаговой инструкции. Если хотите, мы настроим всё за вас или перенесём со старого трекера. Хостинг вы оплачиваете напрямую своему провайдеру.',
  'Install on your own server': 'Установка на свой сервер',
  'Or we set it up for you, on request': 'Или мы настроим всё за вас — по запросу',
  'Your own server or a dedicated cloud, with a licence key.': 'Свой сервер или выделенное облако, с лицензионным ключом.',
  'Monthly or 12 months': 'Помесячно или на 12 месяцев',
};

const es = {
  'Choose your plan': 'Elige tu plan',
  'Every plan includes the whole tracker.': 'Cada plan incluye el tracker completo.',
  '{n} days free': '{n} días gratis',
  'Billed today': 'Se cobra hoy',
  Continue: 'Continuar',
  [PICKER_NOTE]:
    'Start y Pro: {n} días gratis, se requiere tarjeta. Se cobra automáticamente el día {next} salvo que canceles. Una prueba gratuita por cuenta.',
  'Could not load plans.': 'No se pudieron cargar los planes.',
  'Try again': 'Reintentar',
  Plan: 'Plan',
  Change: 'Cambiar',
  'Opening secure payment…': 'Abriendo el pago seguro…',
  'Could not open the payment page. Choose a plan to continue.':
    'No se pudo abrir la página de pago. Elige un plan para continuar.',
  [INTRO]:
    'Start y Pro incluyen {n} días gratis. La tarjeta se pide al inicio: Stripe la verifica pero no cobra nada hasta el día {next}; después el plan se renueva automáticamente. Cancela antes de que termine la prueba y no pagas nada. Team y Network se cobran el día de la suscripción. Una prueba gratuita por cuenta.',
  'Choose a plan to open your workspace.': 'Elige un plan para abrir tu espacio de trabajo.',
  'Payment was not completed. Choose a plan to continue.': 'El pago no se completó. Elige un plan para continuar.',
  'Confirming your payment…': 'Confirmando tu pago…',
  'Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.':
    'Pago recibido, pero la confirmación tarda más de lo normal. Actualiza esta página en un minuto.',
  'Payment confirmed. Welcome aboard!': 'Pago confirmado. ¡Bienvenido!',
  [TRIAL_BANNER]:
    'Prueba gratuita hasta el {date}. Ese día se cobrará la tarjeta automáticamente, no tienes que hacer nada. Cancela antes en Gestionar facturación y no pagas nada.',
  'Start {n}-day free trial': 'Empezar {n} días gratis',
  Subscribe: 'Suscribirse',
  'Your free trial has already been used, so this plan is billed today.':
    'Ya usaste tu prueba gratuita, así que este plan se cobra hoy.',
  'To switch plans, contact support — we move you without losing paid days.':
    'Para cambiar de plan, escribe a soporte: te cambiamos sin perder los días pagados.',
  [ENT_PITCH]:
    'Todo lo de Network, en tu propio servidor o nube, instalado con un solo comando. Usuarios, dominios e historial sin límites.',
  [ENT_AFTER]:
    'Tras el pago emites tu clave de licencia en la página Servidor propio e instalas el tracker tú mismo con un solo comando siguiendo la guía paso a paso. Si lo prefieres, lo configuramos por ti o te migramos desde tu tracker anterior. El alojamiento te lo factura directamente tu proveedor.',
  'Install on your own server': 'Instalación en tu propio servidor',
  'Or we set it up for you, on request': 'O lo configuramos por ti, si lo pides',
  'Your own server or a dedicated cloud, with a licence key.': 'Tu propio servidor o una nube dedicada, con clave de licencia.',
  'Monthly or 12 months': 'Mensual o 12 meses',
};

const pt = {
  'Choose your plan': 'Escolha seu plano',
  'Every plan includes the whole tracker.': 'Todo plano inclui o tracker completo.',
  '{n} days free': '{n} dias grátis',
  'Billed today': 'Cobrado hoje',
  Continue: 'Continuar',
  [PICKER_NOTE]:
    'Start e Pro: {n} dias grátis, cartão obrigatório. Cobrança automática no dia {next}, a menos que você cancele. Um teste grátis por conta.',
  'Could not load plans.': 'Não foi possível carregar os planos.',
  'Try again': 'Tentar novamente',
  Plan: 'Plano',
  Change: 'Alterar',
  'Opening secure payment…': 'Abrindo o pagamento seguro…',
  'Could not open the payment page. Choose a plan to continue.':
    'Não foi possível abrir a página de pagamento. Escolha um plano para continuar.',
  [INTRO]:
    'Start e Pro vêm com {n} dias grátis. O cartão é pedido no início: a Stripe verifica, mas não cobra nada até o dia {next}; depois o plano renova automaticamente. Cancele antes do fim do teste e você não paga nada. Team e Network são cobrados no dia da assinatura. Um teste grátis por conta.',
  'Choose a plan to open your workspace.': 'Escolha um plano para abrir seu espaço de trabalho.',
  'Payment was not completed. Choose a plan to continue.': 'O pagamento não foi concluído. Escolha um plano para continuar.',
  'Confirming your payment…': 'Confirmando seu pagamento…',
  'Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.':
    'Pagamento recebido, mas a confirmação está demorando mais que o normal. Atualize esta página em um minuto.',
  'Payment confirmed. Welcome aboard!': 'Pagamento confirmado. Boas-vindas!',
  [TRIAL_BANNER]:
    'Teste grátis até {date}. Nesse dia o cartão será cobrado automaticamente, não precisa fazer nada. Cancele antes em Gerenciar cobrança e você não paga nada.',
  'Start {n}-day free trial': 'Começar {n} dias grátis',
  Subscribe: 'Assinar',
  'Your free trial has already been used, so this plan is billed today.':
    'Seu teste grátis já foi usado, então este plano é cobrado hoje.',
  'To switch plans, contact support — we move you without losing paid days.':
    'Para trocar de plano, fale com o suporte: mudamos sem perder os dias pagos.',
  [ENT_PITCH]:
    'Tudo do Network, no seu próprio servidor ou nuvem, instalado com um único comando. Usuários, domínios e histórico sem limites.',
  [ENT_AFTER]:
    'Após o pagamento você emite sua chave de licença na página Servidor próprio e instala o tracker você mesmo com um único comando, seguindo o guia passo a passo. Se preferir, configuramos para você ou migramos você do seu tracker antigo. A hospedagem é cobrada diretamente pelo seu provedor.',
  'Install on your own server': 'Instalação no seu próprio servidor',
  'Or we set it up for you, on request': 'Ou configuramos para você, se pedir',
  'Your own server or a dedicated cloud, with a licence key.': 'Seu próprio servidor ou uma nuvem dedicada, com chave de licença.',
  'Monthly or 12 months': 'Mensal ou 12 meses',
};

export const BILLING_INTRO = INTRO;
export const ENTERPRISE_PITCH = ENT_PITCH;
export const ENTERPRISE_AFTER = ENT_AFTER;
export const BILLING_TRIAL_BANNER = TRIAL_BANNER;
const BILLING_FLOW = { ru, es, pt };
export default BILLING_FLOW;
